import React from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import { updateApplyAction } from 'app-components/flux/transaction-rules/transactionRuleActions';
import { useStateContext } from 'app-components/flux/transaction-rules/transactionRulesFormState';
import type { TransactionRuleType } from 'app-components/flux/transaction-rules/transactionRulesTypes';

import useStyles from './styles';

const RuleApplication: React.FC<{ rule?: TransactionRuleType }> = ({ rule }) => {
  const { cx, classes } = useStyles();
  const { dispatch } = useStateContext();

  return (
    <Box className={classes.row} sx={{ alignItems: 'center', py: 1.5, px: 1.5, gap: 0 }}>
      <Checkbox
        id='apply-rule-to-existing'
        checked={!!rule?.applyToExistingTransactions}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          dispatch(updateApplyAction(!!event.target.checked));
        }}
      />
      <Typography className={cx(rule?.applyToExistingTransactions ? classes.highlightText : '')} variant='bodyMedium'>
        Apply rule to existing transactions
      </Typography>
    </Box>
  );
};

export default RuleApplication;
